import { SectionsTreeNode } from '../types';
import { getAllParentNodesByPageId } from './getAllParentNodesByPageId';


export const isMixedProviderMove = (
  sourcePageIds: string[],
  targetPageId: string,
  bundleSections: SectionsTreeNode[]
): boolean => {
  if (sourcePageIds.length === 0) return false;

  // Get source providers from the first cut page
  const sourceParents = getAllParentNodesByPageId(sourcePageIds[0], bundleSections);
  const sourceProvider = sourceParents.provider?.node;

  // Get target provider
  const targetParents = getAllParentNodesByPageId(targetPageId, bundleSections);
  const targetProvider = targetParents.provider?.node;

  if (!sourceProvider || !targetProvider) return false;

  // If same provider, no issue
  if (sourceProvider.id === targetProvider.id) return false;

  // Check if one has date (additional records) and the other doesn't (original)
  const sourceHasDate = !!sourceProvider.date;
  const targetHasDate = !!targetProvider.date;

  // If mixing original (no date) and additional (has date) providers, prevent the move
  return (sourceHasDate && !targetHasDate) || (!sourceHasDate && targetHasDate);
};
